module.exports = {
  message: {
    header: {
      explore: 'Explore Now',
      access: 'Integration Manual',
      operation: 'Operation Guide',
    },
    sidebar: {
      home: 'Home',
      contactus: 'Contact us',
      language: 'Language',
    },
    provides: {
      h1: 'Provides advertising monetization services and solutions',
      p:
        'Connected to top advertising platforms, MINT mediation provides you with monetization,operation and optimization services.',
      started: 'Get started',
      sdk: 'Get SDK',
    },
    why: {
      h1: 'Why Choose MINT?',
      reasons: [
        'Multiple leading advertising platforms in <strong>one SDK</strong>',
        'Flexible bidding modes to <strong>increase the monetization efficiency</strong>',
        'Accurate calculation of LTV & ROI to <strong>guide the marketing</strong> strategy',
        'Both Header Bidding and Waterfall are offered to <strong>maximize your ad revenue</strong>',
        'User status, ad interaction and other data analysis help you better <strong>understand user behaviors</strong>',
        '<strong>Up-to-date data</strong> in all dimensions and <strong>visualized trend</strong> of various data indicators',
      ],
    },
    diversified: {
      h1: 'Diversified Advertising Styles',
      sliderArray: [
        'native',
        'rewarded video',
        'interstitial',
        'splash',
        'banner',
      ],
    },
    aggregated: {
      h1: 'Aggregated Ad Networks',
    },
    intelligent: {
      h1: 'Intelligent CMS',
      p:
        'Supports you to control all aspects of product monetization in real time, and easily realize app configuration, data monitoring, as well as revenue optimization.',
    },
    managed: {
      h1: 'Managed Monetization Operation Service',
      p:
        'Provides you with online monetization service support, and guides you on product access as well as operation optimization.',
      reasons: [
        'Whole-process guidance on the product access',
        'Professional one-to-one optimization service',
        '24-7 online service for operation and technical support',
      ],
    },
    excellent: {
      h1: 'Excellent Case',
    },
    contact: {
      button: 'Contact us',
    },
    footer: {
      about: 'About Xiaomi',
      advertising: 'Advertising Business',
      miads: 'Mi ads',
      blog: 'Blog',
      contact: 'Contact Information',
    },
  },
}
